export default __webpack_public_path__ + "static/maintenance-e6f36362c955fc66b7659cbe54ca2411.jpg";